export { default } from "./Seo";



// WEBPACK FOOTER //
// ./src/components/Seo/index.js